import { createSvgIcon } from '@mui/material';

interface PropTypes {
  filled?: boolean;
}

const TemplateExportIcon = (props: PropTypes) => {
  const { filled } = props;
  const IconCmp = createSvgIcon(
    <>
      <path
        d="M0.75 6.25H17.25M0.75 11.75H17.25M9 0.75V17.25M5.15 0.75H12.85C14.3901 0.75 15.1602 0.75 15.7485 1.04973C16.2659 1.31338 16.6866 1.73408 16.9503 2.25153C17.25 2.83978 17.25 3.60986 17.25 5.15V12.85C17.25 14.3901 17.25 15.1602 16.9503 15.7485C16.6866 16.2659 16.2659 16.6866 15.7485 16.9503C15.1602 17.25 14.3901 17.25 12.85 17.25H5.15C3.60986 17.25 2.83978 17.25 2.25153 16.9503C1.73408 16.6866 1.31338 16.2659 1.04973 15.7485C0.75 15.1602 0.75 14.3901 0.75 12.85V5.15C0.75 3.60986 0.75 2.83978 1.04973 2.25153C1.31338 1.73408 1.73408 1.31338 2.25153 1.04973C2.83978 0.75 3.60986 0.75 5.15 0.75Z"
        stroke="#424242"
        stroke-width="0.9"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </>,
    'TemplateExportIcon',
  );
  const FilledIconCmp = createSvgIcon(
    <>
      <path
        d="M0.75 6.25H17.25M0.75 11.75H17.25M9 0.75V17.25M5.15 0.75H12.85C14.3901 0.75 15.1602 0.75 15.7485 1.04973C16.2659 1.31338 16.6866 1.73408 16.9503 2.25153C17.25 2.83978 17.25 3.60986 17.25 5.15V12.85C17.25 14.3901 17.25 15.1602 16.9503 15.7485C16.6866 16.2659 16.2659 16.6866 15.7485 16.9503C15.1602 17.25 14.3901 17.25 12.85 17.25H5.15C3.60986 17.25 2.83978 17.25 2.25153 16.9503C1.73408 16.6866 1.31338 16.2659 1.04973 15.7485C0.75 15.1602 0.75 14.3901 0.75 12.85V5.15C0.75 3.60986 0.75 2.83978 1.04973 2.25153C1.31338 1.73408 1.73408 1.31338 2.25153 1.04973C2.83978 0.75 3.60986 0.75 5.15 0.75Z"
        stroke="#4E48FA"
        stroke-width="0.9"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </>,
    'TemplateExportIcon',
  );
  return filled ? (
    <FilledIconCmp
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      sx={{ fill: 'none' }}
      {...props}
    />
  ) : (
    <IconCmp
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      sx={{ fill: 'none' }}
      {...props}
    />
  );
};
export default TemplateExportIcon;
